import { toast, ToastPosition } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { NotifyTypes } from './types';

const toastDefaultConfig = {
	position: "top-center" as ToastPosition,
	autoClose: 5000,
	hideProgressBar: false,
	closeOnClick: true,
	pauseOnHover: true,
	draggable: true,
	progress: undefined,
}

export function notify({message, type = 'default', theme = 'light' , options, promise} : NotifyTypes) {

	switch (type) {
		case "default":
			return toast(message, {...toastDefaultConfig, ...options,type: toast.TYPE.DEFAULT,} );

		case "info":
			return toast(message, {...toastDefaultConfig, ...options,type: toast.TYPE.INFO,} );

		case "error":
			return toast(message, {...toastDefaultConfig,...options, theme , type: toast.TYPE.ERROR,} );

		case "success":
			return toast(message, {...toastDefaultConfig, ...options, type: toast.TYPE.SUCCESS,} );

		case "promise":
			if (!promise) {
				break;
			}
			const messages = typeof message === 'object'? message : {pending: 'Enviando dados', success: 'Dados enviados com sucesso', error: "Erros no envio dos dados"}
			return toast.promise( promise, {...toastDefaultConfig, ...messages, ...options,} );
	}
}